import yellow_on_black from '../../../../../assets/chevrons/yellow_on_black.png';
import yellow_on_blue from '../../../../../assets/chevrons/yellow_on_blue.png';
import white_on_blue from '../../../../../assets/chevrons/white_on_blue.png';
import white_on_red from '../../../../../assets/chevrons/white_on_red.png';
import white_on_black from '../../../../../assets/chevrons/white_on_black.png';
import red_on_yellow from '../../../../../assets/chevrons/red_on_yellow.png';
import red_on_white from '../../../../../assets/chevrons/red_on_white.png';
import black_on_white from '../../../../../assets/chevrons/black_on_white.png';
import neonyellow_on_black from '../../../../../assets/chevrons/neonyellow_on_black.png';
import turkey_special_0 from '../../../../../assets/chevrons/turkey_special_0.png';
import burgundy_on_yellow from '../../../../../assets/chevrons/burgundy_on_yellow.png';
import neonyellow_outline from '../../../../../assets/chevrons/neonyellow_outline.png';
import red_outline from '../../../../../assets/chevrons/red_outline.png';

export const CHEVRONS = [
    yellow_on_black,
    yellow_on_blue,
    white_on_blue,
    white_on_red,
    white_on_black,
    red_on_yellow,
    red_on_white,
    black_on_white,
    neonyellow_on_black,
    turkey_special_0,
    burgundy_on_yellow,
    neonyellow_outline,
    red_outline,
];

export const COUNTRY_TO_CHEVRONS: number[][] = [
    [4], // Albania
    [6], // Bosnia and Herzegovina
    [6], // Bulgaria
    [6], // Cyprus
    [6], // Denmark
    [0], // Ireland
    [3], // Estonia
    [3, 5], // Austria
    [6, 5], // Czech Republic
    [0], // Finland
    [2], // France
    [3], // Georgia
    [6], // Germany
    [4], // Greece
    [6, 5], // Croatia
    [3, 7], // Hungary
    [0], // Iceland
    [4], // Italy
    [6], // Latvia
    [3], // Belarus
    [6, 12], // Lithuania
    [6, 5], // Slovakia
    [4], // Liechtenstein
    [6, 7], // The former Yugoslav Republic of Macedonia
    [4], // Malta
    [6], // Belgium
    [6], // Faroe Islands
    [4], // Andorra
    [0, 1], // Luxembourg
    [6], // Monaco
    [7, 5], // Montenegro
    [6], // Netherlands
    [0], // Norway
    [6], // Poland
    [0], // Portugal
    [6, 11], // Romania
    [6], // Republic of Moldova
    [6, 7], // Slovenia
    [2, 4], // Spain
    [1], // Sweden
    [4, 7], // Switzerland
    [6, 11, 0, 8, 9], // Turkey
    [4], // United Kingdom
    [3], // Ukraine
    [10], // San Marino
    [7], // Serbia
    [], // Holy See (Vatican City)
    [3], // Russia
]

export const COUNTRY_TO_COMMON_CHEVRONS = [
    [4], // Albania
    [6], // Bosnia and Herzegovina
    [6], // Bulgaria
    [6], // Cyprus
    [6], // Denmark
    [0], // Ireland
    [3], // Estonia
    [3, 5], // Austria
    [6], // Czech Republic
    [0], // Finland
    [2], // France
    [3], // Georgia
    [6], // Germany
    [4], // Greece
    [6, 5], // Croatia
    [3], // Hungary
    [0], // Iceland
    [4], // Italy
    [6], // Latvia
    [3], // Belarus
    [6, 12], // Lithuania
    [6], // Slovakia
    [4], // Liechtenstein
    [6, 7], // The former Yugoslav Republic of Macedonia
    [4], // Malta
    [6], // Belgium
    [6], // Faroe Islands
    [4], // Andorra
    [0], // Luxembourg
    [6], // Monaco
    [7, 5], // Montenegro
    [6], // Netherlands
    [0], // Norway
    [6], // Poland
    [0], // Portugal
    [6, 11], // Romania
    [6], // Republic of Moldova
    [6], // Slovenia
    [2, 4], // Spain
    [1], // Sweden
    [4], // Switzerland
    [6], // Turkey
    [4], // United Kingdom
    [3], // Ukraine
    [10], // San Marino
    [7], // Serbia
    [], // Holy See (Vatican City)
    [3], // Russia
]
